import { memo } from 'react'
import {
  FieldPath,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { TextField, TextFieldProps } from '@mui/material'

const Input = <
  T extends FieldValues = FieldValues,
  S extends FieldPath<T> = FieldPath<T>,
>({
  name,
  ...props
}: UseControllerProps<T, S> & Omit<TextFieldProps, 'variant'>) => {
  const { t } = useTranslation()
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name })

  return (
    <TextField
      // fullWidth
      value={value ?? ''}
      onChange={onChange}
      error={!!error}
      helperText={
        error?.type === 'custom'
          ? t(`error.${error.type}.${error.message}`)
          : error?.message
      }
      {...props}
    />
  )
}

export default memo(Input) as typeof Input
